import { Directive, ElementRef, Input, OnChanges, SimpleChanges, HostListener, OnInit, inject } from '@angular/core';

@Directive({
  // The user wants 'appTimeAgo' or similar. I'll use 'appRefreshTimeAgo' to be clear.
  selector: '[appRefreshTimeAgo]',
  standalone: true
})
export class RefreshTimeAgoDirective implements OnChanges, OnInit {
  @Input('appRefreshTimeAgo') date: any;

  private el = inject(ElementRef);

  ngOnInit() {
    this.updateText();
    // Also listen to parent hover because the element itself might be hidden initially
    // and only becomes visible when parent is hovered. By that time, we want text updated.
    const parent = this.el.nativeElement.closest('.user-message');
    if (parent) {
      parent.addEventListener('mouseenter', () => this.updateText());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['date']) {
      this.updateText();
    }
  }

  // Keep this for good measure if structure changes
  @HostListener('mouseenter')
  onMouseEnter() {
    this.updateText();
  }

  private updateText() {
    if (!this.date) {
      this.el.nativeElement.innerText = '';
      return;
    }

    const dateVal = new Date(this.date);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - dateVal.getTime()) / 1000);

    if (isNaN(seconds)) {
      this.el.nativeElement.innerText = '';
      return;
    }

    // Handle future dates or very small diffs
    if (seconds < 0) {
      this.el.nativeElement.innerText = 'just now';
      return;
    }

    const intervals: Record<string, number> = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
      second: 1
    };

    if (seconds >= intervals['day']) {
      this.el.nativeElement.innerText = dateVal.toLocaleString([], {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      return;
    }

    for (const i in intervals) {
      const counter = Math.floor(seconds / intervals[i]);
      if (counter > 0) {
        if (counter === 1) {
          this.el.nativeElement.innerText = `${counter} ${i} ago`;
        } else {
          this.el.nativeElement.innerText = `${counter} ${i}s ago`;
        }
        return;
      }
    }

    this.el.nativeElement.innerText = 'just now';
  }
}
